<template>
  <model-list-select
    :list="contractsSelect"
    v-model="contractId"
    option-value="id"
    option-text="id"
    :custom-text="getCustomerText"
    :isDisabled="disabled"
    :placeholder="first"
  >
  </model-list-select>
</template>

<script>
import ModelListSelect from 'vue-search-select/src/lib/ModelListSelect';
export default {
  name: 'SelectContracts',
  components: { ModelListSelect },
  data() {
    return {
      contractId: 0,
      firstOption: this.first ? this.first : 'Todas',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    contractsSelect: {
      type: [Number, String, Array],
    },
    disabled: {
      type: Boolean,
    },
    first: {
      type: String,
    },
  },
  methods: {
    getCustomerText(contract) {
      return `${contract.id} - ${contract.product.name}`;
    },
  },
  watch: {
    contractId() {
      this.$emit('change', this.contractId);
    },
    selected() {
      this.contractId = this.selected;
    },
  },
};
</script>
